import { cx } from '@/styles/muiTheme';

/**
 * Brings an Autocomplete's TextField down to the 32px of the native selects
 * beside it.
 *
 * Height and vertical padding only. The theme's field overrides own the padding
 * model — the wrapper pads and the inner input does not — so this zeroes the
 * wrapper's vertical padding rather than putting any back on the input.
 */
export const filterFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 32,
    minHeight: 32,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: '8px',
    fontSize: 12,
    backgroundColor: cx.bg.surface2,
  },
  '& .MuiOutlinedInput-input': {
    fontSize: 12,
    paddingTop: 0,
    paddingBottom: 0,
  },
} as const;

export default filterFieldSx;
